import React, { ForwardedRef, forwardRef } from 'react';

import { Flex, FlexProps } from '@chakra-ui/react';

export const SectionContainer = forwardRef(({ children, ...props }: FlexProps, ref: ForwardedRef<HTMLDivElement>) => (
  <Flex
    ref={ref}
    bgColor="#fff"
    height="max-content"
    padding="12px 8px"
    flexDir="column"
    w="100%"
    borderRadius="8px"
    {...props}
  >
    {children}
  </Flex>
));
